import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ title, value, change, changeType, icon, iconBg, trend, breakdown }) => {
  const isPositive = changeType === 'positive';
  const isNegative = changeType === 'negative';

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border transition-smooth hover:shadow-organic">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">{value}</h3>
          {breakdown && (
            <p className="text-sm text-gray-500 font-medium mt-1">{breakdown}</p>
          )}
        </div>
        <div 
          className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${iconBg}`}
        >
          <Icon name={icon} size={20} className="md:w-6 md:h-6" />
        </div>
      </div>
      
      {change && (
        <div className="flex items-center gap-2">
          <div className={`flex items-center gap-1 px-2 py-1 rounded-md text-xs md:text-sm font-medium ${
            isPositive ? 'bg-success/10 text-success' : isNegative ?'bg-error/10 text-error': 'bg-muted text-muted-foreground'
          }`}>
            <Icon 
              name={isPositive ? 'TrendingUp' : isNegative ? 'TrendingDown' : 'Minus'} 
              size={14} 
            />
            <span>{change}</span>
          </div>
          {trend && (
            <span className="text-xs md:text-sm text-muted-foreground">{trend}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default StatCard;